//
// The child of an expandable layout entry the user opened last, so that a click on the parent
// returns there. One module-level map shared by every menu instance on the page: the rail, the
// flyout and the mobile panel each resolve their own model, and the flyout mounts a fresh one on
// every open, so a ref inside the hook would lose it. For this session only, like the task view
// Tasks returns to; nothing is written to storage. The click reads it at click time, so nothing
// subscribes.
//

const visitedChildByParent = new Map<string, string>();

/** Records that the user is on `childId`, a child of the expandable entry `parentId`. */
export const setVisitedChild = (parentId: string, childId: string): void => {
  visitedChildByParent.set(parentId, childId);
};

/** The child of `parentId` the user opened last in this session, if any. */
export const getVisitedChild = (parentId: string): string | undefined => visitedChildByParent.get(parentId);
